import { getCloudinaryImageUrl } from '../../../shared/utils/cloudinary.utils';

export function getImageUrl(
	publicId: string | undefined | null,
	placeholder?: string,
	options?: {
		width?: number;
		height?: number;
		crop?: 'fill' | 'thumb' | 'scale';
	}
): string | undefined {
	if (!publicId) {
		return placeholder;
	}
	return getCloudinaryImageUrl(
		import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
		publicId,
		options
	);
}
